import React, { useState, useRef, useEffect, useMemo } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  FaUsers,
  FaCalendarAlt,
  FaEnvelope,
  FaMoneyBillWave,
  FaUserCheck,
  FaChartBar,
  FaAddressCard,
  FaCartPlus,
  FaRegCreditCard,
  FaUserCircle,
  FaFileSignature,
  FaRegNewspaper,
  FaImage,
  FaComment,
  FaHourglassHalf,
  FaCalculator,
  FaShoppingBag,
  FaReact,
  FaCommentMedical,
  FaVoteYea,
  FaDumbbell,
  FaBalanceScale,
  FaBullseye,
  FaExchangeAlt,
  FaLayerGroup,
} from "react-icons/fa";
import { IoMdContacts, IoMdSettings } from "react-icons/io";
import {
  GiBlackBelt,
  GiKimono,
  GiPodiumWinner,
  GiPodium,
  GiGong,
} from "react-icons/gi";
import { MdDashboard, MdTimer, MdOutlineInventory } from "react-icons/md";
import { MdBrowserUpdated } from "react-icons/md";
import { PiTranslateFill } from "react-icons/pi";
import { LuListTodo } from "react-icons/lu";
import { BsClipboardCheckFill } from "react-icons/bs";
import { RiQuestionnaireFill } from "react-icons/ri";
import { GrArticle } from "react-icons/gr";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";

const PREFERRED_VIEW_KEY = "mac_preferred_view";
const CLASSIC_HOME_PATH = "/tableau-de-bord";
const DASHBOARD_HOME_PATH = "/dashboard/tableau-de-bord";

const linkIcon = {
  "Tableau de Bord": <MdDashboard />,
  "Dossier d'Inscription": <FaAddressCard />,
  "Fiche Adhérent": <FaUserCircle />,
  Absences: <FaCommentMedical />,
  Calendrier: <FaCalendarAlt />,
  Messages: <FaEnvelope />,
  Chat: <FaComment />,
  Boutique: <FaCartPlus />,
  "Commandes & Règlements": <FaRegCreditCard />,
  "Prépa Physique": <FaDumbbell />,
  "Documents Passage Ceinture": <GiBlackBelt />,
  "Techniques Judo": <GiKimono />,
  "Techniques Quizz": <GiKimono />,
  "Vote Sondage Utilisateur": <FaVoteYea />,
  Actualités: <FaRegNewspaper />,
  Lexique: <PiTranslateFill />,
  "Arbitrage Judo": <GiGong />,
  "Applications Judo": <FaReact />,
  "Galerie Photos": <FaImage />,
  "Listing Adhérents": <IoMdContacts />,
  "Passage Ceinture": <GiBlackBelt />,
  "Grade CN": <GiBlackBelt />,
  "Prépa Physique Coaching": <FaDumbbell />,
  "Suivi Compétitions": <GiPodiumWinner />,
  Palmarès: <GiPodium />,
  Objectifs: <FaBullseye />,
  ToDoList: <LuListTodo />,
  "Techniques Enseignants": <GiKimono />,
  Catégories: <FaBalanceScale />,
  Événements: <FaCalendarAlt />,
  "Appel Présence": <FaUserCheck />,
  "Tableau Appel": <BsClipboardCheckFill />,
  "Aide Enseignants": <RiQuestionnaireFill />,
  "Dashboard Adhérents": <FaChartBar />,
  "Dashboard Comptabilité": <FaChartBar />,
  "Détails Adhérent": <FaUserCircle />,
  "Listing Utilisateurs": <FaUsers />,
  "Listing Adhérents Admin": <FaUsers />,
  "Règlements Inscriptions": <FaMoneyBillWave />,
  "Dossiers d'Inscription": <FaFileSignature />,
  Paiements: <FaCartPlus />,
  "Articles Admin": <FaShoppingBag />,
  "Dépenses Recettes": <FaCalculator />,
  Coachings: <MdTimer />,
  "Heures Enseignement": <FaHourglassHalf />,
  Inventaire: <MdOutlineInventory />,
  "Prêt Matériel": <GiKimono />,
  "Chat Page Admin": <FaComment />,
  "Message Admin": <FaEnvelope />,
  "Vote Sondage Admin": <FaVoteYea />,
  "Pages Personnalisées": <GrArticle />,
  Paramètres: <IoMdSettings />,
  "Requêtes Admin": <RiQuestionnaireFill />,
  Abonnement: <FaRegCreditCard />,
  Update: <MdBrowserUpdated />,
  "Aide Conseils": <RiQuestionnaireFill />,
};

const sections = {
  2: {
    label: "Utilisateur",
    links: [
      "Tableau de Bord",
      "Dossier d'Inscription",
      "Fiche Adhérent",
      "Absences",
      "Calendrier",
      "Messages",
      "Chat",
      "Boutique",
      "Commandes & Règlements",
      "Prépa Physique",
      "Actualités",
      "Galerie Photos",
      "Lexique",
      "Arbitrage Judo",
      "Applications Judo",
      "Documents Passage Ceinture",
      "Techniques Judo",
      "Techniques Quizz",
      "Vote Sondage Utilisateur",
    ],
  },
  3: {
    label: "Enseignant",
    links: [
      "Listing Adhérents",
      "Appel Présence",
      "Tableau Appel",
      "Passage Ceinture",
      "Grade CN",
      "Événements",
      "Prépa Physique Coaching",
      "Suivi Compétitions",
      "Palmarès",
      "Objectifs",
      "ToDoList",
      "Techniques Enseignants",
      "Catégories",
      "Aide Enseignants",
    ],
  },
  1: {
    label: "Administrateur",
    links: [
      "Dashboard Adhérents",
      "Dashboard Comptabilité",
      "Détails Adhérent",
      "Listing Utilisateurs",
      "Listing Adhérents Admin",
      "Règlements Inscriptions",
      "Dossiers d'Inscription",
      "Paiements",
      "Articles Admin",
      "Dépenses Recettes",
      "Coachings",
      "Heures Enseignement",
      "Inventaire",
      "Prêt Matériel",
      "Chat Page Admin",
      "Message Admin",
      "Vote Sondage Admin",
      "Pages Personnalisées",
      "Paramètres",
      "Requêtes Admin",
      "Abonnement",
      "Update",
      "Aide Conseils",
    ],
  },
};

const DISPLAY_BY_LABEL = {
  Absences: "display_absences",
  Calendrier: "display_calendrier",
  Chat: "display_chat",
  Boutique: "display_boutique",
  "Commandes & Règlements": "display_commandes",
  "Prépa Physique": "display_prepa_physique",
  Actualités: "display_news",
  "Galerie Photos": "display_galerie",
  Lexique: "display_lexique",
  "Arbitrage Judo": "display_arbitrage",
  "Applications Judo": "display_applications",
  "Documents Passage Ceinture": "display_passage_ceinture_documents",
  "Techniques Judo": "display_techniques",
  "Techniques Quizz": "display_techniquesquizz",
  "Vote Sondage Utilisateur": "display_vote",

  "Appel Présence": "display_appels",
  "Tableau Appel": "display_tableauappel",
  "Passage Ceinture": "display_passage",
  "Grade CN": "display_gradecn",
  Événements: "display_evenements",
  "Prépa Physique Coaching": "display_prepa_physique_coaching",
  "Suivi Compétitions": "display_suivicompetition",
  Palmarès: "display_palmares",
  Objectifs: "display_objectifs",
  ToDoList: "display_todolist",
  "Techniques Enseignants": "display_techniquesenseignants",
  Catégories: "display_categories",

  "Articles Admin": "display_articlesadmin",
  "Dépenses Recettes": "display_depensesrecettes",
  Coachings: "display_coaching",
  "Heures Enseignement": "display_heures_enseignants",
  Inventaire: "display_inventaire",
  "Prêt Matériel": "display_pretmateriel",
  "Chat Page Admin": "display_chat_admin",
  "Message Admin": "display_messages_admin",
  "Vote Sondage Admin": "display_voteadmin",
  "Pages Personnalisées": "display_pagespersonnalisees",
};

const coerceBool = (val, fallback = true) => {
  if (val === undefined || val === null) return fallback;
  if (typeof val === "boolean") return val;
  if (typeof val === "number") return val !== 0;

  if (typeof val === "string") {
    const v = val.trim().toLowerCase();

    if (["true", "1", "yes", "on"].includes(v)) return true;
    if (["false", "0", "no", "off"].includes(v)) return false;
  }

  return !!val;
};

const getClassicPathFromLabel = (label) => {
  return `/${String(label)
    .toLowerCase()
    .replace(/[\s'ç]/g, "-")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")}`;
};

const MegaMenu = ({ role_id, settings, closeMegaMenu, onClose }) => {
  const navigate = useNavigate();

  const handleClose = onClose || closeMegaMenu || (() => {});

  const lastActiveTab =
    parseInt(localStorage.getItem("lastActiveTab"), 10) || 0;

  const [activeTab, setActiveTab] = useState(lastActiveTab);
  const [query, setQuery] = useState("");
  const [hasMoreBelow, setHasMoreBelow] = useState(false);

  const [preferredView, setPreferredView] = useState(() => {
    try {
      return localStorage.getItem(PREFERRED_VIEW_KEY) || "classic";
    } catch {
      return "classic";
    }
  });

  const FAV_KEY = `megamenu_favorites_${role_id || "guest"}`;
  const FAV_VIEW_KEY = "megamenu_showFavs";

  const [favorites, setFavorites] = useState(() => {
    try {
      const raw = localStorage.getItem(FAV_KEY);
      const parsed = JSON.parse(raw);

      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  });

  const [showFavsOnly, setShowFavsOnly] = useState(() => {
    try {
      return localStorage.getItem(FAV_VIEW_KEY) === "1";
    } catch {
      return false;
    }
  });

  const [touchStart, setTouchStart] = useState(null);
  const [touchPos, setTouchPos] = useState(null);

  const orderedSections = useMemo(() => {
    if (role_id === 1 || role_id === 4) {
      return [sections[2], sections[3], sections[1]];
    }

    if (role_id === 3) {
      return [sections[2], sections[3]];
    }

    return [sections[2]];
  }, [role_id]);

  useEffect(() => {
    if (activeTab > orderedSections.length - 1) {
      setActiveTab(0);
    }
  }, [activeTab, orderedSections.length]);

  const currentSection =
    orderedSections[activeTab] || orderedSections[0] || sections[2];

  const allLinks = useMemo(
    () => Array.from(new Set(orderedSections.flatMap((s) => s.links))),
    [orderedSections]
  );

  const isFav = (label) => favorites.includes(label);

  const toggleFav = (label) => {
    setFavorites((prev) => {
      if (prev.includes(label)) return prev.filter((l) => l !== label);

      if (prev.length >= 5) {
        window?.alert?.("Vous pouvez enregistrer jusqu'à 5 favoris.");
        return prev;
      }

      return [...prev, label];
    });
  };

  useEffect(() => {
    try {
      localStorage.setItem(FAV_KEY, JSON.stringify(favorites.slice(0, 5)));
    } catch {}
  }, [favorites, FAV_KEY]);

  useEffect(() => {
    try {
      localStorage.setItem(FAV_VIEW_KEY, showFavsOnly ? "1" : "0");
    } catch {}
  }, [showFavsOnly]);

  useEffect(() => {
    localStorage.setItem("lastActiveTab", activeTab);
  }, [activeTab]);

  const handleSwitchView = (view) => {
    const nextView = view === "dashboard" ? "dashboard" : "classic";

    try {
      localStorage.setItem(PREFERRED_VIEW_KEY, nextView);
    } catch {}

    setPreferredView(nextView);

    if (nextView === "dashboard") {
      navigate(DASHBOARD_HOME_PATH);
    } else {
      navigate(CLASSIC_HOME_PATH);
    }

    handleClose();
  };

  const handleClassicLinkClick = () => {
    try {
      localStorage.setItem(PREFERRED_VIEW_KEY, "classic");
    } catch {}

    setPreferredView("classic");
    handleClose();
  };

  let baseLinks;

  if (showFavsOnly) {
    const source = favorites.length ? favorites : [];

    baseLinks = source.filter((l) =>
      !query ? true : l.toLowerCase().includes(query.toLowerCase())
    );
  } else {
    const source = currentSection.links;

    baseLinks = !query
      ? source
      : source.filter((l) => l.toLowerCase().includes(query.toLowerCase()));
  }

  const visibleLinks = baseLinks
    .filter((label) => {
      if (showFavsOnly && !allLinks.includes(label)) return false;

      const key = DISPLAY_BY_LABEL[label];

      if (!key) return true;

      return coerceBool(settings?.[key], true);
    })
    .slice(0, showFavsOnly ? 5 : undefined);

  const startSwipe = (x, y) => setTouchStart({ x, y, t: Date.now() });

  const moveSwipe = (x, y) => setTouchPos({ x, y });

  const endSwipe = () => {
    if (!touchStart || !touchPos) {
      setTouchStart(null);
      setTouchPos(null);
      return;
    }

    const dx = touchPos.x - touchStart.x;
    const dy = touchPos.y - touchStart.y;

    if (!showFavsOnly && Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) {
      if (dx < 0 && activeTab < orderedSections.length - 1) {
        setActiveTab((v) => v + 1);
      } else if (dx > 0 && activeTab > 0) {
        setActiveTab((v) => v - 1);
      }
    }

    setTouchStart(null);
    setTouchPos(null);
  };

  const scrollRef = useRef(null);

  const recomputeHasMore = () => {
    const el = scrollRef.current;

    if (!el) return;

    setHasMoreBelow(el.scrollTop + el.clientHeight < el.scrollHeight - 1);
  };

  useEffect(() => {
    const el = scrollRef.current;

    if (!el) return;

    recomputeHasMore();

    const onScroll = () => recomputeHasMore();

    el.addEventListener("scroll", onScroll);

    return () => el.removeEventListener("scroll", onScroll);
  }, [visibleLinks.length, showFavsOnly]);

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="relative mx-auto max-w-[1280px] overflow-hidden rounded-2xl bg-white/95 shadow-2xl backdrop-blur dark:bg-slate-800/95"
      onTouchStart={(e) =>
        startSwipe(e.touches[0].clientX, e.touches[0].clientY)
      }
      onTouchMove={(e) => moveSwipe(e.touches[0].clientX, e.touches[0].clientY)}
      onTouchEnd={endSwipe}
      onPointerDown={(e) => {
        if (e.pointerType !== "mouse") startSwipe(e.clientX, e.clientY);
      }}
      onPointerMove={(e) => {
        if (e.pointerType !== "mouse" && touchStart) {
          moveSwipe(e.clientX, e.clientY);
        }
      }}
      onPointerUp={(e) => {
        if (e.pointerType !== "mouse") endSwipe();
      }}
    >
      <div className="sticky top-0 z-10 border-b border-slate-800 bg-slate-900 text-white">
        <div className="px-4 py-3 md:px-6">
          <div className="flex flex-wrap items-center gap-2">
            <div className="order-1 flex flex-wrap items-center gap-2">
              {orderedSections.map((section, idx) => (
                <button
                  key={section.label}
                  onClick={() => setActiveTab(idx)}
                  type="button"
                  className={`rounded-full px-3 py-1.5 text-sm font-semibold transition-colors md:px-4 ${
                    activeTab === idx && !showFavsOnly
                      ? "bg-primary text-white"
                      : "bg-slate-800 text-slate-200 hover:bg-slate-700"
                  } ${showFavsOnly ? "pointer-events-none opacity-50" : ""}`}
                >
                  {section.label}
                </button>
              ))}
            </div>

            <button
              onClick={handleClose}
              type="button"
              aria-label="Fermer le menu"
              className="order-2 ml-auto inline-flex h-10 w-10 items-center justify-center rounded-full bg-primary text-white shadow-md transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 md:order-4 md:ml-0"
            >
              x
            </button>

            <div className="order-3 w-full md:order-2 md:ml-auto md:w-[min(520px,65%)]">
              <div className="flex items-center gap-2">
                <input
                  type="text"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder={
                    showFavsOnly
                      ? "Rechercher dans vos favoris…"
                      : "Rechercher une fonctionnalité…"
                  }
                  className="flex-1 rounded-xl border border-slate-700 bg-slate-800 px-3 py-2 text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-primary/50"
                />

                <button
                  type="button"
                  onClick={() => setShowFavsOnly((v) => !v)}
                  title={
                    showFavsOnly
                      ? "Afficher tout le menu"
                      : "N’afficher que mes favoris"
                  }
                  className={`inline-flex h-10 w-10 items-center justify-center rounded-full shadow-md transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 ${
                    showFavsOnly
                      ? "bg-rose-600 text-white"
                      : "bg-slate-800 text-rose-500 hover:bg-slate-700"
                  }`}
                >
                  {showFavsOnly ? (
                    <AiFillHeart className="text-xl" />
                  ) : (
                    <AiOutlineHeart className="text-xl" />
                  )}
                </button>

                <span className="hidden rounded-full bg-slate-800 px-2 py-1 text-xs text-slate-200 ring-1 ring-slate-700 md:inline-block">
                  {favorites.length}/5
                </span>

                {role_id === 1 && (
                  <NavLink
                    to="/parametres"
                    onClick={handleClassicLinkClick}
                    aria-label="Ouvrir les paramètres"
                    className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-primary text-white shadow-md transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50"
                  >
                    <IoMdSettings className="text-xl" />
                  </NavLink>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        ref={scrollRef}
        className="relative max-h-[70vh] overflow-y-auto overflow-x-hidden px-4 py-4 md:px-6"
      >
        <div className="mb-4 grid gap-3 md:grid-cols-2">
          <button
            type="button"
            onClick={() => handleSwitchView("classic")}
            className={`group rounded-2xl border p-4 text-left shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-xl ${
              preferredView === "classic"
                ? "border-primary bg-primary/10 ring-2 ring-primary/20 dark:border-primary dark:bg-primary/10"
                : "border-slate-200 bg-white hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:hover:bg-slate-800"
            }`}
          >
            <div className="flex items-start gap-3">
              <span
                className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl text-xl ${
                  preferredView === "classic"
                    ? "bg-primary text-white"
                    : "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200"
                }`}
              >
                <FaLayerGroup />
              </span>

              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <p className="font-bold text-slate-900 dark:text-white">
                    Vue classique
                  </p>

                  {preferredView === "classic" && (
                    <span className="rounded-full bg-primary px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white">
                      Active
                    </span>
                  )}
                </div>

                <p className="mt-1 text-sm leading-5 text-slate-500 dark:text-slate-300">
                  Accéder aux pages actuelles de MonAppliClub, pages par pages.
                </p>
              </div>
            </div>
          </button>

          <button
            type="button"
            onClick={() => handleSwitchView("dashboard")}
            className={`group rounded-2xl border p-4 text-left shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-xl ${
              preferredView === "dashboard"
                ? "border-primary bg-gradient-to-r from-[#013E8E] to-[#4CA82F] text-white ring-2 ring-primary/20"
                : "border-slate-200 bg-white hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:hover:bg-slate-800"
            }`}
          >
            <div className="flex items-start gap-3">
              <span
                className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl text-xl ${
                  preferredView === "dashboard"
                    ? "bg-white/20 text-white"
                    : "bg-primary/10 text-primary"
                }`}
              >
                <MdDashboard />
              </span>

              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <p
                    className={`font-bold ${
                      preferredView === "dashboard"
                        ? "text-white"
                        : "text-slate-900 dark:text-white"
                    }`}
                  >
                    Nouveau dashboard
                  </p>

                  {preferredView === "dashboard" && (
                    <span className="rounded-full bg-white px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-[#013E8E]">
                      Active
                    </span>
                  )}
                </div>

                <p
                  className={`mt-1 text-sm leading-5 ${
                    preferredView === "dashboard"
                      ? "text-white/85"
                      : "text-slate-500 dark:text-slate-300"
                  }`}
                >
                  Ouvrir la nouvelle interface sous forme de Tableau de bord.
                </p>
              </div>
            </div>
          </button>
        </div>

        <div className="mb-4 flex items-center gap-3">
          <div className="h-px flex-1 bg-slate-200 dark:bg-slate-700" />
          <div className="flex items-center gap-2 rounded-full bg-slate-100 px-3 py-1 text-xs font-bold uppercase tracking-[0.18em] text-slate-500 dark:bg-slate-900 dark:text-slate-400">
            <FaExchangeAlt />
            Menu classique
          </div>
          <div className="h-px flex-1 bg-slate-200 dark:bg-slate-700" />
        </div>

        {visibleLinks.length > 0 ? (
          <ul
            className="grid gap-3 md:gap-4"
            style={{
              gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
            }}
          >
            {visibleLinks.map((link, linkIdx) => (
              <li key={`${link}-${linkIdx}`} className="min-w-0">
                <NavLink
                  to={getClassicPathFromLabel(link)}
                  onClick={handleClassicLinkClick}
                  className="group relative block w-full max-w-full min-w-0 rounded-xl bg-white p-3 shadow-sm ring-1 ring-slate-200 transition-all duration-200 hover:shadow-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 dark:bg-slate-800 dark:ring-slate-700"
                >
                  <span className="pointer-events-none absolute bottom-0 left-0 top-0 w-[6px] rounded-l-xl bg-primary opacity-0 transition-opacity group-hover:opacity-100" />

                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      toggleFav(link);
                    }}
                    title={
                      isFav(link)
                        ? "Retirer des favoris"
                        : "Ajouter aux favoris"
                    }
                    className="absolute right-2 top-2 inline-flex h-8 w-8 items-center justify-center rounded-full bg-white/90 text-rose-500 shadow ring-1 ring-slate-200 hover:scale-105 dark:bg-slate-700/90 dark:ring-slate-600"
                  >
                    {isFav(link) ? <AiFillHeart /> : <AiOutlineHeart />}
                  </button>

                  <div className="flex flex-col items-center text-center">
                    <div className="mb-2 inline-flex h-14 w-14 items-center justify-center rounded-xl bg-primary/10 text-3xl text-primary transition-transform group-hover:scale-110">
                      {linkIcon[link]}
                    </div>

                    <span className="break-words text-[13px] font-semibold leading-tight text-slate-800 dark:text-slate-100">
                      {link}
                    </span>
                  </div>
                </NavLink>
              </li>
            ))}
          </ul>
        ) : (
          <div className="py-10 text-center text-sm text-slate-500 dark:text-slate-300">
            {showFavsOnly
              ? "Vous n’avez pas encore de favoris."
              : `Aucune entrée ne correspond à “${query}”.`}
          </div>
        )}

        {hasMoreBelow && !showFavsOnly && (
          <>
            <div className="pointer-events-none absolute bottom-0 left-0 right-0 h-10 bg-gradient-to-t from-white to-transparent dark:from-slate-800" />

            <div className="pointer-events-none absolute bottom-2 left-1/2 -translate-x-1/2">
              <span className="rounded-full bg-white/90 px-2 py-1 text-[11px] text-slate-600 shadow dark:bg-slate-800/90 dark:text-slate-200">
                Faites défiler pour voir plus
              </span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MegaMenu;